import { render } from "./issue.vue?vue&type=template&id=ced28054"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css"
import "./issue.vue?vue&type=style&index=1&id=ced28054&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__